import { z } from "zod";

import { OrgShopCurrencyDtoSchema } from "../../../../../dtos/organizations";

export const PluginShopCurrencySchema_2023_08_20 = OrgShopCurrencyDtoSchema;
export type PluginShopCurrencyType_2023_08_20 = z.infer<
  typeof PluginShopCurrencySchema_2023_08_20
>;
